import { Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import EnquiryPopup from './components/EnquiryPopup';
import Home from './pages/Home';  
import Shop from './pages/Shop';
import Rings from './pages/Rings';
import DiamondJewellery from './pages/DiamondJewellery';
import Necklaces from './pages/Necklaces';
import About from './components/About';
import ContactSection from './components/ContactSection';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import ReturnsPolicy from './pages/ReturnsPolicy';

function App() {
  return (
    <>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/rings" element={<Rings />} />
        <Route path="/diamond-jewellery" element={<DiamondJewellery />} />
        <Route path="/necklaces" element={<Necklaces />} />
        <Route path="/contact" element={<ContactSection />} />
        <Route path="/about" element={<About />} />
        <Route path='/privacy'element={<PrivacyPage/> }/>
        <Route path='/terms'element={<TermsPage/>}/>
        <Route path="/returns" element={<ReturnsPolicy />} />
      </Routes>

      <EnquiryPopup />
      <Footer />
    </>
  );
}

export default App;